import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeItem, inceament, deceament } from '../redux/features/pageSlice';
import { Trash } from 'lucide-react';

const ShoppingPage = () => {
  const dispatch = useDispatch();
  const { items } = useSelector(state => state.page);

  const totalPrice = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  if (!items || items.length === 0) {
    return <div className="text-center text-lg font-semibold mt-4">Your shopping bag is empty</div>;
  }

  return (
    <div className="max-w-lg mx-auto bg-white shadow-lg rounded-lg p-4">
      <h1 className="text-2xl font-semibold text-center mb-4">Shopping Bag</h1>
      
      {items.map((item) => (
        <div key={item.id} className="grid grid-cols-[1.5fr,0.5fr,0.5fr,1fr,0.5fr] items-center bg-gray-100 p-1 rounded-md mb-1">
          {/* Title with ellipsis if too long */}
          <p className="text-sm font-medium truncate w-64">{item.title}</p>

          {/* Decrease Quantity OR Remove */}
          {item.quantity <= 1 ? (
            <button onClick={() => dispatch(removeItem(item.id))} className="text-red-500 hover:text-red-700">
              <Trash size={16} />
            </button>
          ) : (
            <button onClick={() => dispatch(deceament(item.id))} className="text-gray-600 hover:text-gray-800 text-sm px-2">
              -
            </button>
          )}

          <p className="text-sm text-center">{item.quantity}</p>

          {/* Total Price for this item */}
          <p className="text-sm font-medium text-center">${(item.quantity * item.price).toFixed(2)}</p>

          {/* Increase Quantity */}
          <button onClick={() => dispatch(inceament(item.id))} className="text-gray-600 hover:text-gray-800 text-sm px-2">
            +
          </button>
        </div>
      ))}

      {/* Display Total Price */}
      <h1 className="mt-3 text-lg font-bold text-center">Total: ${totalPrice.toFixed(2)}</h1>
    </div>
  );
};

export default ShoppingPage;
